import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { ContainerProps, ImmutableState } from '../../types';

const cleanup =
	() =>
	(_: StoreActionApi<ImmutableState>, { activeStreams }: ContainerProps): void => {
		activeStreams && activeStreams.unsubscribe();
	};

export default cleanup;
